import { createClient } from "@supabase/supabase-js";

class Supabase {
    _client;

    _channels = {};

    constructor() {
        const projectRef = process.env.REACT_APP_SUPABASE_PROJECT_REF;
        const anon = process.env.REACT_APP_SUPABASE_ANON;
        this._client = createClient(`https://${projectRef}.supabase.co`, anon, {
            realtime: {
                params: {
                    eventsPerSecond: 10
                }
            }
        });
    }

    createChannel(channelId) {
        this._channels[channelId] = this._client.channel(channelId);
        return this._channels[channelId];
    }

    channel(channelId) {
        return this._channels[channelId];
    }

    getClient() {
        return this._client;
    }

    on(channelId, type, filter, callback) {
        this._channels[channelId].on(type, filter, callback);
    }

    subscribe(channelId, callback) {
        this._channels[channelId].subscribe(callback);
    }

    async removeAllChannels() {
        return this._client.removeAllChannels();
    }

    /*
    // Pagination
    .range(0, 9)

    // Filters
    .eq('column', 'Equal to')
    .gt('column', 'Greater than')
    .lt('column', 'Less than')
    .gte('column', 'Greater than or equal to')
    .lte('column', 'Less than or equal to')
    .like('column', '%CaseSensitive%')
    .ilike('column', '%CaseInsensitive%')
    .is('column', null)
    .in('column', ['Array', 'Values'])
    .neq('column', 'Not equal to')

    // Arrays
    .cs('array_column', ['array', 'contains'])
    .cd('array_column', ['contained', 'by'])
     */
    async select(table, columns) {
        return this._client.from(table).select(columns);
    }

    async insert(table, data, upsert) {
        if (!Array.isArray(data)) data = [data];
        if (upsert) data.push({ upsert: true });
        return this._client.from(table).insert(data);
    }

    async update(table, data, filterCol, filterValue) {
        return this._client.from(table).update(data).eq(filterCol, filterValue);
    }

    async delete(table, filterCol, filterValue) {
        return this._client.from(table).delete().eq(filterCol, filterValue);
    }
}

export default Supabase;